<template>
  <div class="code" :class="{ 'ac-bg-gray': ac }">
    <!-- <header-component :is-soon="false" img-left="/trocachip/img/setinha-left-preto.svg" img-right="/trocachip/img/access.png" class="header-component" /> -->
    <header-component
      :is-soon="false"
      :backRoute="true"
      img-left="/trocachip/img/fechar.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />

    <div
      :class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"
    ></div>

    <div id="title" class="container loading_send_code" v-if="pageLoading">
      <h2
        class="code_title loading"
        id="code_title_loading"
        :class="{ 'ac-color-white': ac }"
      >
        Aguarde enquanto enviamos seu código
      </h2>
      <span class="code_subtitle loading" id="code_subtitle_loading"
        >Vamos enviar um código de verificação por sms.</span
      >
      <loader-bottom
        class="loading_indicator"
        id="loading_indicator"
        :isBlue="true"
      />
    </div>

    <div class="container" v-if="!pageLoading">
      <img
        src="../assets/images/sms.svg"
        alt="ícone vermelho identificador de SMS"
        title="ícone de sms"
      />
      <h2 class="code_title" :class="{ 'ac-color-white': ac }">SMS enviado</h2>
      <span class="code_subtitle"
        >Digite abaixo o código enviado para o número<br />{{
          getUserPhone()
        }}</span
      >
      <section class="code_number">
        <div   class="number_inputs" id="number_inputs" ref="numbers_inputs">
          <input
            v-for="(value, index) in smsCodeValues"
            @paste="handlePaste"
            @change="createCode($event, index)"
            @keydown="clearCode"
            :key="index"
            type="text"
            inputmode="numeric"
            v-model="smsCodeValues[index]"
            :name="index"
            maxlength="1"
            id="pinfield"
            ref="pinfield"
            @input="handleInput(index, $event)"
          />
        </div>
      </section>

      <div class="next_submit">
        <button
          id="resendpinbutton"
          class="btn_next"
          :class="{
            'btn_next_active transparent': !conTab,
            bt_no_click: loader,
            'ac-border-yellow': ac,
            'ac-bg-gray': ac,
            'ac-color-yellow': ac,
          }"
          :disabled="conTab"
          @click="newCode(true)"
        >
          <progress-bar-circular
            @enableButton="activeButtonResend"
            ref="progressBar"
          />
          <span>Reenviar</span>
        </button>
        <button
          id="continuepin"
          class="btn_next grey"
          :class="{
            btn_next_active: isValid,
            bt_no_click: loader,
            'ac-border-yellow': ac,
            'ac-bg-gray': ac,
            'ac-color-yellow': ac,
            btn_next_active_loader: loader,
          }"
          :disabled="!isValid"
          @click="validatePin()"
        >
          <loader-bottom v-if="loader" />
          <span v-if="!loader">Continuar</span>
        </button>
      </div>
    </div>
    <alert
      description="O código foi reenviado para o seu celular"
      success="true"
      message="O envio do SMS com o código é muito rápido, mas as vezes pode demorar alguns minutos. "
      tracker="Troca de Chip Reenvio SMS"
      v-on:close="closeSms"
      v-if="modalOpen"
    />
    <alert
      danger="true"
      :description="errorModal.title"
      :message="errorModal.description"
      :action="errorModal.button"
      :tracker="errorModal.tracker"
      :closeButtonActive="false"
      v-on:close="this.errorModal.action"
      v-if="errorModalActived"
    />
  </div>
</template>

<script>
import LoaderBottom from "../components/LoaderBottom.vue";
import Alert from "../components/Alert.vue";
import HeaderComponent from "../components/HeaderComponent.vue";
import Pin from "../services/pin";
import EmailEligibility from "../services/emailEligibility";
import trackEvent from "../services/trackEvent";
import { mapState } from "vuex";
import ProgressBarCircular from "../components/ProgressBarCircular.vue";
import Vue from "vue";
// import ContabComponent from "../components/ContabComponent.vue";

export default {
  name: "Code",
  components: {
    Alert,
    HeaderComponent,
    // ContabComponent,
    LoaderBottom,
    ProgressBarCircular,
  },
  data() {
    return {
      code: "",
      loader: false,
      errors: {
        incomplete: false,
      },
      isValid: false,
      modalOpen: false,
      invalidPin: false,
      codeDispatchErrorModal: false,
      conTab: true,
      sendCodeErrorMessage: {},
      smsCodeInputPlaceholder: "",
      smsCodeValues: ["", "", "", "", "", ""],
      inputs: null,
      pageLoading: true,
      errorModal: {},
      errorModalActived: false,
      errorDesc: ""
    };
  },
  created() {
    this.$store.dispatch("progressEnabled", true);
    if (this.document === "") return this.$router.push("/documentos");
    this.smsCodeInputPlaceholder = this.config.sms_code_placeholder;

    this.validateCodeErrorMessage = this.config.validateCodeErrorMessage
      ? this.config.validateCodeErrorMessage
      : {};
    this.requestPin();
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      document: (state) => state.document,
      config: (state) => state.config,
      sendCodeMaxErrorAmount: (state) => state.config.sendCodeMaxErrorAmount,
      validateCodeMaxErrorAmount: (state) =>
        state.config.validateCodeMaxErrorAmount,
      pinToken: (state) => state.pinToken,
      sendCodeErrorCount: (state) => state.sendCodeErrorCount,
      validateCodeErrorCount: (state) => state.validateCodeErrorCount,
      customer: (state) => state.customer,
      progressValue: (state) => state.progressValue,
      progressEnabled: (state) => state.progressEnabled,
      tokenConsultErrors: (state) => state.tokenConsultErrors,
      emailValidation: (state) => state.config.emailValidation,
    }),
  },
  watch: {
    code: function () {
      console.log("Code changed: "+this.code)
      this.errors.incomplete = this.code.length > 0 && this.code.length < 6;
      this.isValid = this.code.length === 6;
    },
  },
  methods: {
    getUserPhone() {
      const userPhone = this.customer.login;
      return userPhone.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) *****-$3");
    },
    createCode(e, valueIndex) {
      this.smsCodeValues[valueIndex] = e.target.value;
      this.code = "";

      this.smsCodeValues.forEach((value) => {
        this.code += value;
      });
    },
    clearCode(e) {
      if (e.key === "Backspace") {
        this.smsCodeValues[e.target.name] = "";
        this.code = "";

        const input = e.target;
        if (!input.value && input.previousSibling) {
          input.previousSibling.focus();
        }

        return;
      } else if (e.key === "Delete") {
        this.smsCodeValues[e.target.name] = "";
        this.code = "";

        const input = e.target;
        if (!input.value && input.nextSibling) {
          input.nextSibling.focus();
        }

        return;
      }
    },
    handlePaste(event) {
      // Get pasted text and split into characters
      const pastedText = event.clipboardData.getData('text').trim();
      // Validate: Only numbers allowed
      if (!/^\d+$/.test(pastedText) || pastedText.length != 6) {
        event.preventDefault();
        return;
      }
      const pastedDigits = pastedText.split('').slice(0, 6);

      // Update each digit in the model
      pastedDigits.forEach((digit, index) => {
        this.smsCodeValues[index] = digit;
      });
      this.code=pastedDigits
      // Prevent default to avoid iOS native paste
      event.preventDefault();
    },
    handleInput(index, event) {
      // Optional: Auto-advance to next input
      const value = event.target.value;
      if (value.length === 1 && index < 5) {
        this.$nextTick(() => {
          this.$refs.pinfield[index + 1].focus();
        });
      }
    },
    returnToInit() {
      this.$store.dispatch("sendCodeErrorCount", 0);
      this.$store.dispatch("validateCodeErrorCount", 0);
      this.$router.push("/");
    },
    async requestPin() {
      if (this.progressValue == 0) {
        await Pin.RequestCustomerPin()
          .then((response) => {
            this.pageLoading = false;
            this.conTab = true;
            this.$store.dispatch("progressEnabled", true);
            this.$store.dispatch("pinToken", response.data.pinToken);
          })
          .catch(() => {
            this.$store.dispatch(
              "sendCodeErrorCount",
              this.sendCodeErrorCount + 1
            );
            this.pageLoading = false;
            this.restoreProgress();
            this.codeDispatchErrorModal = true;
            this.stopContab();
            this.code = "";
            this.smsCodeValues = ["", "", "", "", "", ""];

            if (this.sendCodeErrorCount >= this.sendCodeMaxErrorAmount)
              return this.exceedTokenSendErrors();
            return this.tokenSendError();
          });
      } else {
        this.pageLoading = false;
      }
    },
    stopContab() {
      this.conTab = false;
    },
    validatePin() {
      try {
        if (!this.isLoading) {
          this.loader = true;
          const shouldCheckEmailEligibility =
            this.emailValidation.eligibilityCheckEnabled &&
            this.emailValidation.eligibilityBillingProfileSegments.includes(
              this.customer.segment
            );

          if (shouldCheckEmailEligibility) {
            EmailEligibility.checkEligibility(this.customer.login)
              .then((_) => {
                localStorage.setItem("@trocachip/email-eligibility", _);
                console.log("Retorno da API ", _);
                if (
                  this.smsCodeValues.toString() ==
                    this.config.bypass_token_value.toString() &&
                  this.config.enable_bypass_token == true
                ) {
                  this.$store.dispatch("allowReserve");
                  this.$store.dispatch("code", this.code);

                  return this.$router.push(this.getRoute());
                } else {
                  this.next()
                    .then(() => {
                      this.enable_bypass_token = true;
                    })
                    .catch(() => {
                      this.next();
                    });
                }
              })
              .catch((_) => {
                console.error(_);
                return this.$router.push({ name: "default-error" });
              });
          } else {
            if (
              this.smsCodeValues.toString() ==
                this.config.bypass_token_value.toString() &&
              this.config.enable_bypass_token == true
            ) {
              this.$store.dispatch("allowReserve");
              console.log("CODIGO: ", this.code);
              this.$store.dispatch("code", this.code);
              return this.$router.push(this.getRoute());
            } else {
              this.next()
                .then(() => {
                  this.enable_bypass_token = true;
                })
                .catch(() => {
                  this.next();
                });
            }
          }
        }
      } catch (_) {
        console.error(_);
        return this.$router.push({ name: "default-error" });
      }
    },
    async next() {
      if (!this.isLoading) {
        this.loader = true;
        
        try {
          // Wait for the store update to complete before validating
          await this.$store.dispatch("code", this.code);
          console.log("CóDIGO 2: ", this.code)
          await Pin.validateCustomerPin();
          this.loader = false;
          this.invalidPin = false;
          this.trackSMSEvent("Sucesso", 2, "");
          this.$store.dispatch("allowReserve");
          return this.$router.push(this.getRoute());
        } catch (error) {
          await this.$store.dispatch(
            "validateCodeErrorCount",
            this.validateCodeErrorCount + 1
          );
          this.isValid = false;
          this.loader = false;
          this.invalidPin = true;
          this.trackSMSEvent(
            "Falha",
            3,
            "Troca de Chip Erro Envio Codigo SMS"
          );
          
          if (
            this.validateCodeErrorCount % this.validateCodeMaxErrorAmount === 0 ||
            this.validateCodeErrorCount >= 9
          ) {
            if (this.validateCodeErrorCount >= 9) {
              return this.exceedProceedAndTokenSendErrors();
            }
            return this.exceedTokenErrors();
          }
          return this.tokenErro();
        }
      }
    },
    getRoute() {
      console.log("FLOW " + this.isExOi());
      if (
        ((this.$store.getters.getFlowSelected == "chipToChip" ||
          this.$store.getters.getFlowSelected == "eSimToChip") &&
          !this.config.enable_email_validation_chip) ||
        (this.isExOi() && !this.config.enable_email_change_for_oi)
      )
        return "instrucoes-barcode";

      if (
        (this.$store.getters.getFlowSelected == "chipToESim" ||
          this.$store.getters.getFlowSelected == "eSimToESim") &&
        !this.config.enable_email_validation_eSim
      )
        return "loading-page";

      return "/new-email-validation";
    },
    trackSMSEvent(status, action, label) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: "",
          lineType: this.customer.loginType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": 6,
        "event-action": action,
        "event-label": label,
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": status,
        "event-interactionNumber": "",
        "event-error": "",
        "event-errorDetail": "",
      });
    },
    async newCode(openModal) {
      this.trackSMSEvent("Sucesso", 2, "Troca de Chip Reenviar Codigo SMS");
      if (!this.conTab && this.progressValue == 0) {
        this.resendCode();
        this.conTab = true;
        this.codeDispatchErrorModal = false;

        await Pin.RequestCustomerPin(this.$store.getters.getDocument)
          .then((response) => {
            this.$store.dispatch("pinToken", response.data.pinToken);
            this.trackSMSEvent("Sucesso", 3, "Troca de Chip Envio Codigo SMS");
            if (openModal) this.modalOpen = true;
          })
          .catch((response) => {
            this.$store.dispatch(
              "sendCodeErrorCount",
              this.sendCodeErrorCount + 1
            );
            this.errorDesc = response.desc
            this.codeDispatchErrorModal = true;
            this.code = "";
            this.smsCodeValues = ["", "", "", "", "", ""];
            this.restoreProgress();
            this.stopContab();
            this.trackSMSEvent(
              "Falha",
              3,
              "screen_erro_tokens_sms_"+response.desc
            );

            if (this.sendCodeErrorCount >= this.sendCodeMaxErrorAmount)
              return this.exceedTokenSendErrors();
            return this.tokenSendError();
          });
      } else this.codeDispatchErrorModal = false;
    },
    async closeSms() {
      this.modalOpen = !this.modalOpen;
    },
    restoreProgress() {
      this.$store.dispatch("progressValue", 0);
      this.$store.dispatch("progressEnabled", false);
      this.conTab = false;
    },
    resendCode() {
      Vue.nextTick(() => {
        this.$store.dispatch("progressEnabled", true);
        this.$store.dispatch("progressValue", 1);
        this.$refs.progressBar.start_progress();
        console.log("CODIGO REENVIADO");
      });
    },
    activeButtonResend() {
      this.conTab = false;
    },
    tokenErro() {
      this.errorModal = this.config.proceedCodeErrorMessage.error
        ? this.config.proceedCodeErrorMessage.error
        : {};
      this.errorModal.action = () => {
        (this.errorModalActived = false), (this.code = "");
        this.smsCodeValues = ["", "", "", "", "", ""];
      };
      this.errorModalActived = true;
    },
    exceedTokenErrors() {
      this.errorModal = this.config.proceedCodeErrorMessage.maxAttemptsError
        ? this.config.proceedCodeErrorMessage.maxAttemptsError
        : {};
      this.errorModal.action = () => {
        this.$store.dispatch("tokenConsultErrors", 0);
        this.errorModalActived = false;
        this.restoreProgress();
        this.stopContab();
        this.newCode(true);
        this.code = "";
        this.smsCodeValues = ["", "", "", "", "", ""];
      };
      this.errorModalActived = true;
    },
    tokenSendError() {
      this.trackSMSEvent("Falha", "3", "screen_erro_token_sms_erro_envio_de_token")
      this.errorModal = this.config.sendCodeErrorMessage.error
        ? this.config.sendCodeErrorMessage.error
        : {};
      this.errorModal.action = () => {
        this.errorModalActived = false;
        this.$refs.progressBar.end_progress();
        this.trackSMSEvent("Sucesso", "2", "tentar_novamente_erro_token_sms_erro_envio_de_token")
      };
      this.errorModalActived = true;
    },
    exceedTokenSendErrors() {
      this.errorModal = this.config.sendCodeErrorMessage.maxAttemptsError
        ? this.config.sendCodeErrorMessage.maxAttemptsError
        : {};
      this.errorModal.action = () => {
        this.returnToInit();
      };
      this.errorModalActived = true;
    },
    exceedProceedAndTokenSendErrors() {
      this.errorModal = this.config.proceedAndSendTokenErrorMessage
        ? this.config.proceedAndSendTokenErrorMessage
        : {};
      this.errorModal.action = () => {
        this.trackSMSEvent(
              "Falha",
              2,
              this.errorModal.tracker
            )
        this.$store.dispatch("tokenConsultErrors", 0);
        this.returnToInit();
      };
      this.errorModalActived = true;
    },
    isExOi() {
      if (this.config["init_flow"] === undefined) {
        this.alertError = true;
      }

      return JSON.parse(this.customer.isExOiCustomer);
    },
  },
};
</script>

<style lang="scss" scoped>
.code {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;
  .bt_no_click {
    z-index: -1;
  }
  > .container {
    margin: 25% 5% !important;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    > .code_title {
      width: 265px;
      display: block;
      position: relative;
      margin: 24px auto 0 auto;
      font-family: "timsans_regular";
      font-size: 24px;
      font-weight: 300;
      line-height: 1.11;
      text-align: center;
      color: #000000;
    }
    > .code_title.loading {
      font-size: 27px !important;
      line-height: 30px;
    }
    > .code_subtitle {
      font-family: "timsans_regular";
      text-align: center;
      line-height: 24px;
      margin-top: 8px;
      color: #696969;
      width: 80%;
    }
    > .code_subtitle.loading {
      margin-top: 44px;
      max-width: 70%;
    }
    > .loading_indicator {
      margin-top: 100px;
    }
    > .code_number {
      width: 90%;
      height: auto;
      display: flex;
      justify-content: center;
      position: relative;
      margin: 35px auto 0 auto;
      .number_inputs {
        display: flex;
        flex-direction: row;
        > input {
          width: 46px;
          height: 62px;
          background-color: transparent;
          border: 1px solid #000000;
          text-align: center;
          border-radius: 16px;
          color: #000000;
          font-family: "timsans_regular";
          font-size: 24px;
          margin-right: 8px;
          padding: 0 !important;
          &:last-of-type {
            margin-right: 0px;
          }
        }
      }
      > label {
        width: 100%;
        height: auto;
        font-family: "timsans_regular";
        font-size: 0.75em;
        color: #6c6c6c;
      }
      > label.code-label-error {
        color: #ec0028 !important;
      }
      > input {
        font-size: 12px;
        color: #b3b3b3;
      }
    }
    > .code_new_send {
      width: 252px;
      margin: 16px auto;
      display: block;
      font-family: "timsans_regular";
      font-size: 0.875em;
      text-align: center;
      > a {
        color: #001ccf;
        text-decoration: underline;
      }
      > a.disabled {
        color: #b3b3b3;
        text-decoration: underline;
      }
      > span {
        float: left;
        > i {
          color: #001ccf;
          text-decoration: underline;
          float: right;
          display: flex;
          flex-wrap: nowrap;
          > .cron {
            min-width: 12px;
            padding-left: 0.2em;
            padding-right: 0.2em;
          }
        }
      }
    }
    > .code_not_send {
      width: auto;
      margin: 16px auto;
      display: block;
      font-family: "timsans_regular";
      font-size: 0.875em;
      text-align: center;
      color: #ec0028;
      > a {
        color: #001ccf;
        text-decoration: underline;
      }
      > span {
        float: left;
        > i {
          color: #001ccf;
          text-decoration: underline;
          float: right;
          display: flex;
          flex-wrap: nowrap;
          > .cron {
            min-width: 12px;
            padding-left: 0.2em;
            padding-right: 0.2em;
          }
        }
      }
    }
    .next_submit {
      height: unset !important;
      > .btn_next.grey {
        margin-top: 24px;
      }
    }
  }
}

.btn_next_active_loader {
  width: 52px !important;
  transition: width 2s;
}

@media (min-width: 768px) {
  .code {
    width: 100%;
    height: 100%;
    display: grid;
    grid-auto-columns: 50% 50%;
    grid-template-areas:
      "header header"
      "container background";
    position: absolute;
    z-index: -1;
    .bt_no_click {
      z-index: -1;
    }

    .header-component {
      width: 45%;
      grid-area: header;
    }

    .background-desktop {
      grid-area: background;
      width: 100%;
      height: 100vh;
      display: block;
      background: url("../assets/images/desktop@3x.png") no-repeat;
      background-size: cover;
    }

    .background-desktop-black {
      grid-area: background;
      width: 100%;
      height: 100vh;
      display: block;
      background: url("../assets/images/desktop-black.png") no-repeat;
      background-size: cover;
    }

    > .container {
      grid-area: container;
      > .code_title {
        width: 434px;
        height: auto;
        display: block;
        margin: 115px auto 0 auto;
        font-family: "timsans_thin";
        font-size: 2em;
        font-weight: 300;
        line-height: 1.2;
      }

      > .code_number {
        width: 400px;
        height: auto;
        display: flex;
        position: relative;
        margin: 64px auto 0 auto;
        > label {
          width: 100%;
          height: auto;
          font-family: "timsans_regular";
          font-size: 0.75em;
          color: #6c6c6c;
        }
      }

      > .code_new_send {
        width: 390px;
        margin: 16px auto;
        font-family: "timsans_regular";
        font-size: 0.875em;
        text-align: center;
        > span {
          width: 380px;
          display: block;
          margin: 0 auto;
          text-align: center;
          > i {
            color: #001ccf;
            > .cron {
              min-width: 12px;
              padding-left: 0.2em;
              padding-right: 0.2em;
            }
          }
        }
      }
    }
  }
}
</style>
